import { formatForEdit, parseDecimalInput } from "./decimalInput";

/** What Копирај takes from Размерување into one Материјално item. */
export interface RazmerCopySource {
  qty: string;
  serialNumber: string;
  expiryDate: string;
  /** Measured in more than one lot (distinct serials) — must be entered manually. */
  multipleLots: boolean;
}

interface RazmerRowLike {
  itemId?: string;
  subprocessId?: string;
  measuredQty?: string;
  serialNumber?: string;
  expiryDate?: string;
}

/** itemId → copy source, built from the filled Размерување rows of one subprocess. */
export const buildRazmerCopySources = (
  rows: RazmerRowLike[],
  subprocessId: string,
): Record<string, RazmerCopySource> => {
  const byItem: Record<string, RazmerRowLike[]> = {};
  rows.forEach((row) => {
    if (row.subprocessId !== subprocessId || !row.itemId) return;
    if (!(row.measuredQty || "").trim()) return;
    (byItem[row.itemId] = byItem[row.itemId] || []).push(row);
  });

  const result: Record<string, RazmerCopySource> = {};
  Object.entries(byItem).forEach(([itemId, itemRows]) => {
    const serials = new Set(
      itemRows.map((r) => (r.serialNumber || "").trim()).filter(Boolean),
    );
    if (serials.size > 1) {
      result[itemId] = { qty: "", serialNumber: "", expiryDate: "", multipleLots: true };
      return;
    }
    let qty = (itemRows[0].measuredQty || "").trim();
    if (itemRows.length > 1) {
      const sum = itemRows.reduce((acc, r) => acc + (parseDecimalInput(r.measuredQty) ?? 0), 0);
      qty = formatForEdit(sum);
    }
    const expiryRow = itemRows.find((r) => (r.expiryDate || "").trim());
    result[itemId] = {
      qty,
      serialNumber: serials.size === 1 ? Array.from(serials)[0] : "",
      expiryDate: expiryRow ? (expiryRow.expiryDate || "").trim() : "",
      multipleLots: false,
    };
  });
  return result;
};
